"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __exportStar = void 0 && (void 0).__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.writeToPath = exports.writeToString = exports.writeToBuffer = exports.writeToStream = exports.write = exports.format = exports.FormatterOptions = exports.CsvFormatterStream = void 0;
var util_1 = require("util");
var stream_1 = require("stream");
var fs = __importStar(require("fs"));
var FormatterOptions_1 = require("./FormatterOptions");
var CsvFormatterStream_1 = require("./CsvFormatterStream");
__exportStar(require("./types"), exports);
var CsvFormatterStream_2 = require("./CsvFormatterStream");
Object.defineProperty(exports, "CsvFormatterStream", {
  enumerable: true,
  get: function get() {
    return CsvFormatterStream_2.CsvFormatterStream;
  }
});
var FormatterOptions_2 = require("./FormatterOptions");
Object.defineProperty(exports, "FormatterOptions", {
  enumerable: true,
  get: function get() {
    return FormatterOptions_2.FormatterOptions;
  }
});
exports.format = function (options) {
  return new CsvFormatterStream_1.CsvFormatterStream(new FormatterOptions_1.FormatterOptions(options));
};
exports.write = function (rows, options) {
  var csvStream = exports.format(options);
  var promiseWrite = util_1.promisify(function (row, cb) {
    csvStream.write(row, undefined, cb);
  });
  rows.reduce(function (prev, row) {
    return prev.then(function () {
      return promiseWrite(row);
    });
  }, Promise.resolve()).then(function () {
    return csvStream.end();
  }).catch(function (err) {
    csvStream.emit('error', err);
  });
  return csvStream;
};
exports.writeToStream = function (ws, rows, options) {
  return exports.write(rows, options).pipe(ws);
};
exports.writeToBuffer = function (rows) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var buffers = [];
  var ws = new stream_1.Writable({
    write: function write(data, enc, writeCb) {
      buffers.push(data);
      writeCb();
    }
  });
  return new Promise(function (res, rej) {
    ws.on('error', rej).on('finish', function () {
      return res(Buffer.concat(buffers));
    });
    exports.write(rows, opts).pipe(ws);
  });
};
exports.writeToString = function (rows, options) {
  return exports.writeToBuffer(rows, options).then(function (buffer) {
    return buffer.toString();
  });
};
exports.writeToPath = function (path, rows, options) {
  var stream = fs.createWriteStream(path, {
    encoding: 'utf8'
  });
  return exports.write(rows, options).pipe(stream);
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7QUFDQTtBQUNBO0FBRUE7QUFDQTtBQUVBQTtBQUNBO0FBQVNDO0VBQUFDO0VBQUFDO0lBQUEsOENBQWtCO0VBQUE7QUFBQTtBQUMzQjtBQUFTRjtFQUFBQztFQUFBQztJQUFBLDBDQUFnQjtFQUFBO0FBQUE7QUFFWkMsY0FBTSxHQUFHLFVBQStCQyxPQUFvQztFQUFBLE9BQ3JGLElBQUlDLHVDQUFrQixDQUFDLElBQUlDLG1DQUFnQixDQUFDRixPQUFPLENBQUMsQ0FBQztBQUFBO0FBRTVDRCxhQUFLLEdBQUcsVUFDakJJLElBQVMsRUFDVEgsT0FBb0MsRUFDVjtFQUMxQixJQUFNSSxTQUFTLEdBQUdMLGNBQU0sQ0FBQ0MsT0FBTyxDQUFDO0VBQ2pDLElBQU1LLFlBQVksR0FBR0MsZ0JBQVMsQ0FBQyxVQUFDQyxHQUFNLEVBQUVDLEVBQWtDLEVBQVU7SUFDaEZKLFNBQVMsQ0FBQ0ssS0FBSyxDQUFDRixHQUFHLEVBQUVHLFNBQVMsRUFBRUYsRUFBRSxDQUFDO0VBQ3ZDLENBQUMsQ0FBQztFQUNGTCxJQUFJLENBQUNRLE1BQU0sQ0FDUCxVQUFDQyxJQUFtQixFQUFFTCxHQUFNO0lBQUEsT0FBb0JLLElBQUksQ0FBQ0MsSUFBSSxDQUFDO01BQUEsT0FBcUJSLFlBQVksQ0FBQ0UsR0FBRyxDQUFDO0lBQUEsRUFBQztFQUFBLEdBQ2pHTyxPQUFPLENBQUNDLE9BQU8sRUFBRSxDQUNwQixDQUNJRixJQUFJLENBQUM7SUFBQSxPQUFZVCxTQUFTLENBQUNZLEdBQUcsRUFBRTtFQUFBLEVBQUMsQ0FDakNDLEtBQUssQ0FBQyxVQUFDQyxHQUFHLEVBQVU7SUFDakJkLFNBQVMsQ0FBQ2UsSUFBSSxDQUFDLE9BQU8sRUFBRUQsR0FBRyxDQUFDO0VBQ2hDLENBQUMsQ0FBQztFQUNOLE9BQU9kLFNBQVM7QUFDcEIsQ0FBQztBQUVZTCxxQkFBYSxHQUFHLFVBQ3pCcUIsRUFBSyxFQUNMakIsSUFBUyxFQUNUSCxPQUFvQztFQUFBLE9BQ2hDRCxhQUFLLENBQUNJLElBQUksRUFBRUgsT0FBTyxDQUFDLENBQUNxQixJQUFJLENBQUNELEVBQUUsQ0FBQztBQUFBO0FBRXhCckIscUJBQWEsR0FBRyxVQUN6QkksSUFBUyxFQUVRO0VBQUEsSUFEakJtQiwyRUFBbUMsRUFBRTtFQUVyQyxJQUFNQyxPQUFPLEdBQWEsRUFBRTtFQUM1QixJQUFNSCxFQUFFLEdBQUcsSUFBSUksaUJBQVEsQ0FBQztJQUNwQmYsS0FBSyxpQkFBQ2dCLElBQUksRUFBRUMsR0FBRyxFQUFFQyxPQUFPO01BQ3BCSixPQUFPLENBQUNLLElBQUksQ0FBQ0gsSUFBSSxDQUFDO01BQ2xCRSxPQUFPLEVBQUU7SUFDYjtHQUNILENBQUM7RUFDRixPQUFPLElBQUliLE9BQU8sQ0FBQyxVQUFDZSxHQUFHLEVBQUVDLEdBQUcsRUFBVTtJQUNsQ1YsRUFBRSxDQUFDVyxFQUFFLENBQUMsT0FBTyxFQUFFRCxHQUFHLENBQUMsQ0FBQ0MsRUFBRSxDQUFDLFFBQVEsRUFBRTtNQUFBLE9BQVlGLEdBQUcsQ0FBQ0csTUFBTSxDQUFDQyxNQUFNLENBQUNWLE9BQU8sQ0FBQyxDQUFDO0lBQUEsRUFBQztJQUN6RXhCLGFBQUssQ0FBQ0ksSUFBSSxFQUFFbUIsSUFBSSxDQUFDLENBQUNELElBQUksQ0FBQ0QsRUFBRSxDQUFDO0VBQzlCLENBQUMsQ0FBQztBQUNOLENBQUM7QUFFWXJCLHFCQUFhLEdBQUcsVUFDekJJLElBQVMsRUFDVEgsT0FBb0M7RUFBQSxPQUNsQkQscUJBQWEsQ0FBQ0ksSUFBSSxFQUFFSCxPQUFPLENBQUMsQ0FBQ2EsSUFBSSxDQUFDLFVBQUNxQixNQUFNO0lBQUEsT0FBYUEsTUFBTSxDQUFDQyxRQUFRLEVBQUU7RUFBQSxFQUFDO0FBQUE7QUFFakZwQyxtQkFBVyxHQUFHLFVBQ3ZCcUMsSUFBWSxFQUNaakMsSUFBUyxFQUNUSCxPQUFvQyxFQUNwQjtFQUNoQixJQUFNcUMsTUFBTSxHQUFHQyxFQUFFLENBQUNDLGlCQUFpQixDQUFDSCxJQUFJLEVBQUU7SUFBRUksUUFBUSxFQUFFO0VBQU0sQ0FBRSxDQUFDO0VBQy9ELE9BQU96QyxhQUFLLENBQUNJLElBQUksRUFBRUgsT0FBTyxDQUFDLENBQUNxQixJQUFJLENBQUNnQixNQUFNLENBQUM7QUFDNUMsQ0FBQyIsIm5hbWVzIjpbIl9fZXhwb3J0U3RhciIsIk9iamVjdCIsImVudW1lcmFibGUiLCJnZXQiLCJleHBvcnRzIiwib3B0aW9ucyIsIkNzdkZvcm1hdHRlclN0cmVhbV8xIiwiRm9ybWF0dGVyT3B0aW9uc18xIiwicm93cyIsImNzdlN0cmVhbSIsInByb21pc2VXcml0ZSIsInV0aWxfMSIsInJvdyIsImNiIiwid3JpdGUiLCJ1bmRlZmluZWQiLCJyZWR1Y2UiLCJwcmV2IiwidGhlbiIsIlByb21pc2UiLCJyZXNvbHZlIiwiZW5kIiwiY2F0Y2giLCJlcnIiLCJlbWl0Iiwid3MiLCJwaXBlIiwib3B0cyIsImJ1ZmZlcnMiLCJzdHJlYW1fMSIsImRhdGEiLCJlbmMiLCJ3cml0ZUNiIiwicHVzaCIsInJlcyIsInJlaiIsIm9uIiwiQnVmZmVyIiwiY29uY2F0IiwiYnVmZmVyIiwidG9TdHJpbmciLCJwYXRoIiwic3RyZWFtIiwiZnMiLCJjcmVhdGVXcml0ZVN0cmVhbSIsImVuY29kaW5nIl0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==